import logo from '../../../assets/logo_sgsante.svg';
import retractedLogo from '../../../assets/logo_min.png';

import interimaire from '../../../components/Layout/Logos/img/interimaire_prevoyance_logo2.png';
import { Box } from '@material-ui/core';

type Props = {
    drawerOpen: boolean;
    numAdherent: string;
};

const LogoSelecteur: React.FC<Props> = ({ drawerOpen, numAdherent }) => {
    const logoToShow = numAdherent === 'XX9904752' ? interimaire : logo;
    const retractedLogoToShow = numAdherent === '9904752' ? interimaire : retractedLogo;
    const height = numAdherent === 'XX9904752' ? 40 : 70;
    return (
        <>
            {drawerOpen ? (
                <Box style={{ minWidth: '190px', marginLeft: '10px' }} className="text-center pb-2">
                    <img style={{ marginLeft: -20 }} src={logoToShow} alt="logo-extranet-rh" height={height} width="auto" />
                </Box>
            ) : (
                <img style={{ marginLeft: -20 }} src={retractedLogoToShow} alt="logo-extranet-rh" height="70" width="auto" />
            )}
        </>
    );
};

export default LogoSelecteur;
